import { variants } from '@eti/components';
import { css } from '@eti/styles';
import { useTranslation } from '@eti/providers';
import { forwardRef } from 'react';
import isFunction from 'lodash/isFunction';
import { Button, Inline } from '@etg/wings';
import { seatMapFooterStyles } from '../utils/styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const footerButtonStyles = css`
  align-items: center;
  display: inline-flex;
  height: 48px;
  justify-content: center;
  min-width: 120px;
  padding: 0 12px;
  white-space: nowrap;

  @media (max-width: 768px) {
    flex: 1;
    min-width: 0;
  }
`;
const footerButtonWrapperStyles = isFirstSegment => css`
  justify-content: ${isFirstSegment ? 'flex-end' : 'space-between'};
`;
const SeatMapFooter = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    onClose,
    onSaveAndContinue,
    shouldShowSummary,
    isFirstSegment,
    handlePreviousSegmentClick,
    areAllSeatsSelected,
    setShowAllSeatsSelectedConfirmation,
    totalPrice,
    isPostBooking,
    selectNoOption,
    selectedSeats,
    isSkipButtonFocused
  } = _ref;
  const {
    t
  } = useTranslation();
  const saveAndContinueLabel = t('Product.SeatMap.Button.Continue');
  const segmentBackLabel = t('Button.Text.Back');
  const handleNext = e => {
    if (!shouldShowSummary) {
      onSaveAndContinue(e);
      return;
    }
    if (!areAllSeatsSelected && isFunction(setShowAllSeatsSelectedConfirmation)) {
      setShowAllSeatsSelectedConfirmation(true);
      return;
    }
    if (totalPrice === 0 && isPostBooking) {
      selectNoOption();
      return;
    }
    onClose(selectedSeats);
  };
  return /*#__PURE__*/_jsx("div", {
    className: seatMapFooterStyles(isSkipButtonFocused),
    "data-testid": "seatMapFooter",
    ref: ref,
    children: /*#__PURE__*/_jsxs(Inline, {
      className: footerButtonWrapperStyles(isFirstSegment),
      children: [!isFirstSegment && /*#__PURE__*/_jsx(Button, {
        className: footerButtonStyles,
        "data-testid": "segment-back-button",
        onClick: handlePreviousSegmentClick,
        variant: variants.SECONDARY,
        children: segmentBackLabel
      }), /*#__PURE__*/_jsx(Button, {
        className: footerButtonStyles,
        "data-testid": "saveAndContinue-button",
        id: "saveAndContinue-button",
        onClick: handleNext,
        variant: variants.PRIMARY,
        children: saveAndContinueLabel
      })]
    })
  });
});
export default SeatMapFooter;
//# sourceMappingURL=SeatMapFooter.js.map